import { FC, useState } from 'react';

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { NbButton } from '@/components/Neobrut';
import { CustomMap } from './CustomMap';

interface LocationPickerProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: LocationIQReverseGeocodingResponse) => void;
}

const LocationPicker: FC<LocationPickerProps> = ({ open, onClose, onSubmit }) => {
  const [response, setResponse] = useState<LocationIQReverseGeocodingResponse | null>(null);

  const handleSubmit = () => {
    if (!response) return;
    onSubmit(response);
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent
        className="animate-in fade-in zoom-in-95 left-1/2 top-1/2 flex max-h-[90vh] w-full max-w-[92%] -translate-x-1/2 -translate-y-1/2 flex-col overflow-y-auto p-4 duration-200 ease-out sm:max-w-lg"
        style={{
          background: 'var(--nb-paper)',
          border: '3px solid var(--nb-ink)',
          boxShadow: '6px 6px 0 var(--nb-ink)',
          borderRadius: 'var(--nb-radius)',
        }}
      >
        <DialogHeader>
          <div
            className="text-[10px] font-bold uppercase tracking-[0.08em] opacity-60"
            style={{ fontFamily: '"JetBrains Mono", monospace' }}
          >
            / ubicación
          </div>
          <DialogTitle className="font-display text-[22px] leading-tight">
            Marcá la ubicación en el mapa
          </DialogTitle>
        </DialogHeader>

        <div className="flex flex-grow flex-col gap-3 pt-2">
          <div className="h-[400px]">
            <CustomMap setResponse={setResponse} />
          </div>

          <div
            className="p-3 text-[13px] font-semibold"
            style={{
              border: '2px solid var(--nb-ink)',
              background: 'var(--nb-paper)',
              borderRadius: 'var(--nb-radius)',
            }}
          >
            <div
              className="mb-1 text-[10px] font-bold uppercase tracking-[0.08em] opacity-60"
              style={{ fontFamily: '"JetBrains Mono", monospace' }}
            >
              / seleccionada
            </div>
            {response?.display_name ?? 'Tocá el mapa para seleccionar una ubicación.'}
          </div>
        </div>

        <div
          className="sticky bottom-0 z-10 mt-3 grid grid-cols-2 gap-2 pt-3"
          style={{ borderTop: '2px solid var(--nb-ink)', background: 'var(--nb-paper)' }}
        >
          <NbButton fill="paper" onClick={onClose}>
            Cancelar
          </NbButton>
          <NbButton fill="ink" disabled={!response} onClick={handleSubmit}>
            Aceptar
          </NbButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LocationPicker;
